var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClutchGlobalBadge = function SvgClutchGlobalBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 233 200"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clutchGlobalBadge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DCDA9",
    fillRule: "evenodd",
    d: "M33.431 130.529H-.009l11.798-17.863L-.01 93.851h33.441zm166.128 0H233l-11.799-17.863L233 93.851h-33.441z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5EAF91",
    d: "m17.25 119.718 22.222 12.321-7.885-20.065H17.25zm198.274 0-22.222 12.321 7.885-20.065h14.337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17313B",
    d: "M207.11 50.087v99.784l-90.054 49.913-90.097-49.913V50.087L117.056.216l90.054 49.87z",
    filter: "url(#clutchGlobalBadge_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6DCDA9",
    strokeMiterlimit: 10,
    d: "M207.11 50.087v99.784l-90.054 49.913-90.097-49.913V50.087L117.056.216l90.054 49.87z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#clutchGlobalBadge_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#clutchGlobalBadge_svg__d)",
    d: "M198.264 54.326v91.347l-81.422 45.697-81.469-45.697V54.326L116.842 8.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clutchGlobalBadge_svg__e)",
    d: "M198.264 54.326v91.347l-81.422 45.697-81.469-45.697V54.326L116.842 8.63z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#clutchGlobalBadge_svg__f)",
    strokeMiterlimit: 10,
    strokeWidth: 10,
    d: "M199.343 54.326v-.631l-.551-.31L117.37 7.69l-.528-.296-.528.296-81.468 45.697-.552.309v92.61l.552.309 81.468 45.697.528.296.528-.296 81.422-45.697.551-.309z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DCDA9",
    fillRule: "evenodd",
    d: "M17.25 119.741c0 .119.097.216.216.216h198.058a.216.216 0 0 0 .216-.216V83.495a.216.216 0 0 0-.216-.216H17.466a.216.216 0 0 0-.216.216z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.608 43.15h-3.667v20.065h3.667zm12.19 13.985c0 3.138-2.873 3.373-3.699 3.373-2.047 0-2.558-1.844-2.558-2.942v-7.728h-2.912v7.728c0 1.922.59 3.53 1.692 4.629.984.941 2.361 1.451 3.974 1.451 1.26 0 2.283-.392 3.503-1.098v.55h3.344v-13.26h-3.344zm10.146-11.827h-3.673v4.691h-2.05v2.58h2.05v10.636h3.673V52.58h2.476V50h-2.476zm13.252 14.031a4.04 4.04 0 0 1-2.777.974c-2.346 0-4.106-1.675-4.106-3.934 0-2.298 1.681-3.856 4.106-3.856a4.57 4.57 0 0 1 2.816.973l.508.429 2.269-2.181-.587-.507c-1.369-1.168-3.168-1.83-5.045-1.83-4.224 0-7.313 2.921-7.313 6.972 0 4.05 3.168 7.05 7.313 7.05a7.56 7.56 0 0 0 5.084-1.83l.548-.507-2.308-2.181zm14.976-8.132c-.981-.939-2.393-1.447-4.001-1.447-1.255 0-2.589.391-3.53 1.095V43.15h-3.335v20.065h3.335v-6.962c0-3.13 2.667-3.364 3.491-3.364 2 0 2.353 1.838 2.353 2.933v7.393h3.335v-7.393c-.04-1.955-.51-3.559-1.648-4.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D2E",
    d: "M134.294 58.9c1.371 0 2.482-1.063 2.482-2.373s-1.111-2.374-2.482-2.374c-1.37 0-2.481 1.063-2.481 2.374 0 1.31 1.111 2.373 2.481 2.373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.897 58.557c-1.296 1.253-3.063 1.997-4.909 1.957-3.81 0-6.558-2.858-6.558-6.773s2.749-6.812 6.558-6.812c1.846 0 3.613.705 4.87 1.958l.51.509 2.278-2.193-.51-.509c-1.885-1.879-4.477-2.897-7.187-2.897-5.577 0-9.779 4.268-9.779 9.945 0 5.676 4.202 9.904 9.78 9.904 2.709 0 5.3-1.018 7.186-2.897l.51-.509-2.238-2.231-.51.548zm8.748 86.858v-12.233h4.727v1.223h-3.02v4.078h2.34v1.208h-2.34v5.724zm6.48 0 2.597-12.233h1.646l2.613 12.233h-1.616l-.559-3.081h-2.492l-.589 3.081zm2.416-4.304h2.039l-1.027-5.512zm7.192 4.304v-12.233h1.706v11.01h3.126v1.223zm7.512 0v-12.233h1.707v11.01h3.126v1.223zm-21.11 23.085v-.819l2.222-3.463q.248-.388.453-.723a3.3 3.3 0 0 0 .345-.701q.14-.378.14-.863 0-.604-.194-.949-.194-.346-.68-.346-.41 0-.636.227a1.2 1.2 0 0 0-.313.593 3.5 3.5 0 0 0-.086.788v.291h-1.154v-.302q0-.788.205-1.349a1.8 1.8 0 0 1 .679-.884q.475-.313 1.252-.313 1.056 0 1.575.604.517.594.517 1.651 0 .56-.14.981a3.7 3.7 0 0 1-.345.788q-.216.366-.475.755l-2.006 3.064h2.761v.97zm8.581.097q-.744 0-1.229-.334a2.02 2.02 0 0 1-.712-.917 3.6 3.6 0 0 1-.227-1.327v-3.765q0-.765.227-1.337.226-.584.701-.906.485-.324 1.24-.324.756 0 1.23.324.475.322.701.906.227.572.227 1.337v3.765q0 .756-.237 1.338a1.96 1.96 0 0 1-.702.917q-.474.324-1.219.323m0-.949q.411 0 .615-.237.216-.238.292-.604.086-.378.086-.777v-3.786a4 4 0 0 0-.076-.788 1.2 1.2 0 0 0-.291-.604q-.204-.226-.626-.226-.42 0-.636.226a1.2 1.2 0 0 0-.291.604 4 4 0 0 0-.076.788v3.786q0 .399.076.777.086.367.302.604.226.237.625.237m4.3.852v-.819l2.223-3.463q.248-.388.453-.723a3.4 3.4 0 0 0 .345-.701q.14-.378.14-.863 0-.604-.194-.949-.194-.346-.68-.346-.41 0-.636.227a1.2 1.2 0 0 0-.313.593 3.4 3.4 0 0 0-.086.788v.291h-1.155v-.302q0-.788.205-1.349.216-.572.68-.884.474-.313 1.251-.313 1.057 0 1.575.604.518.594.518 1.651 0 .56-.14.981a3.7 3.7 0 0 1-.345.788q-.216.366-.475.755l-2.006 3.064h2.761v.97zm8.356.097q-.712 0-1.187-.269a1.7 1.7 0 0 1-.712-.777q-.237-.507-.237-1.197v-.292h1.143v.195q.01.387.086.701.087.312.292.496.216.183.615.183.42 0 .636-.194.216-.204.291-.572a4 4 0 0 0 .076-.841q0-.69-.259-1.122-.248-.443-.885-.485a.3.3 0 0 0-.086-.011h-.075v-1.154h.151q.614-.022.884-.324t.27-1.003q0-.594-.205-.949-.194-.356-.788-.356-.593 0-.787.399-.194.388-.216 1.003v.183h-1.143v-.291q0-.702.237-1.197.237-.497.712-.766.486-.27 1.197-.27.723 0 1.198.27.474.269.712.776.237.496.237 1.198 0 .787-.345 1.262a1.67 1.67 0 0 1-.906.647q.399.119.669.41.28.291.431.744.151.443.151 1.036 0 .777-.216 1.359-.216.572-.69.896-.475.312-1.251.312M83.33 111.785q-1.76 0-2.794-.748t-1.496-2.113q-.44-1.386-.44-3.257v-5.986q0-1.914.44-3.3.44-1.388 1.54-2.113 1.122-.75 3.081-.749 1.827 0 2.905.617a3.46 3.46 0 0 1 1.54 1.782q.484 1.145.484 2.795v.924h-3.103v-1.012q0-.859-.131-1.474-.11-.617-.485-.925-.351-.33-1.166-.33-.858 0-1.254.418-.375.42-.484 1.1-.089.683-.088 1.497v7.46q0 .924.153 1.607.154.683.573 1.056.417.352 1.188.352.793 0 1.21-.396.42-.396.573-1.1.176-.704.176-1.673v-1.672h-1.915v-2.047h4.841v9.045h-2.09l-.242-1.761a3.45 3.45 0 0 1-1.079 1.453q-.703.55-1.936.55zm10.027-.242V93.718h3.257v15.58h4.313v2.245zm16.09.242q-1.893 0-3.015-.704-1.122-.705-1.607-2.025-.483-1.32-.484-3.125v-6.668q0-1.805.484-3.08.485-1.3 1.607-1.981 1.122-.683 3.015-.683 1.936 0 3.037.683 1.122.682 1.606 1.98.506 1.276.506 3.081v6.69q0 1.783-.506 3.103-.484 1.299-1.606 2.025-1.1.704-3.037.704m0-2.399q.815 0 1.188-.352.396-.352.528-.968t.132-1.343v-8.208q0-.748-.132-1.342t-.528-.925q-.373-.351-1.188-.352-.771 0-1.167.352-.396.33-.528.925a6.2 6.2 0 0 0-.132 1.342v8.208q0 .727.11 1.343.132.616.528.968c.396.352.661.352 1.189.352m9.759 2.157V93.718h4.379q1.188 0 2.135.22.968.22 1.65.748.704.506 1.079 1.386.374.88.374 2.223 0 1.078-.308 1.848-.286.771-.859 1.233-.572.44-1.43.594 1.056.176 1.739.748.704.55 1.034 1.453.352.902.352 2.178c0 1.276-.11 1.607-.33 2.267q-.309.968-.946 1.628-.617.639-1.563.969-.924.33-2.179.33zm3.257-2.289h1.232q1.475 0 2.003-.704.528-.726.528-2.223 0-1.078-.264-1.738a1.8 1.8 0 0 0-.836-1.013q-.573-.33-1.541-.33h-1.122zm0-8.252h1.1q.969 0 1.497-.286a1.5 1.5 0 0 0 .726-.88q.22-.595.22-1.497 0-.945-.33-1.453-.309-.528-.946-.704-.639-.198-1.629-.198h-.638zm10.27 10.541 3.565-17.825h3.477l3.565 17.825h-3.015l-.704-4.115h-3.103l-.727 4.115zm4.115-6.184h2.421l-1.211-7.482zm10.485 6.184V93.718h3.257v15.58h4.313v2.245z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "clutchGlobalBadge_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-159.34696 182.7401 -367.3441 -320.31922 194.72 8.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5272"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "clutchGlobalBadge_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-159.34696 182.7401 -367.3441 -320.31922 194.72 8.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5272"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "clutchGlobalBadge_svg__b",
    width: 180.151,
    height: 203.568,
    x: 26.959,
    y: 0.216,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1906_11066"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "clutchGlobalBadge_svg__c",
    width: 162.891,
    height: 186.74,
    x: 35.373,
    y: 8.63,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1906_11066"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clutchGlobalBadge_svg__f",
    x1: 42.16,
    x2: 370.886,
    y1: -237.461,
    y2: 40.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2AE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#BD9155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#F9E2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#BD9155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clutchGlobalBadge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.01 0H233v200H-.01z"
  })))));
};
export default SvgClutchGlobalBadge;